<template>
  <section class="app-cta">
    <div class="container">
      <div class="app-cta__inner">
        <div class="app-cta__content">
          <h2 class="app-cta__title">
            更多课程与导师内容，尽在 Go Trust App
          </h2>
          <button class="btn-primary btn-primary--lg" @click="$emit('download')">
            立即下载 App
          </button>
        </div>
        <div class="app-cta__qr">
          <div class="app-cta__qr-item">
            <div class="app-cta__qr-box">
              <div class="app-cta__qr-placeholder" />
            </div>
            <span>Android</span>
          </div>
          <div class="app-cta__qr-item">
            <div class="app-cta__qr-box">
              <div class="app-cta__qr-placeholder" />
            </div>
            <span>iOS</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppCTA',
  emits: ['download'],
}
</script>

<style scoped>
.app-cta {
  padding: 32px 0;
}

.app-cta__inner {
  background: var(--color-primary);
  border-radius: var(--radius-xl);
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  align-items: center;
  text-align: center;
}

.app-cta__title {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-white);
  line-height: 1.5;
  margin-bottom: 20px;
}

.app-cta__qr {
  display: flex;
  gap: 24px;
}

.app-cta__qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: var(--color-white);
  font-size: 13px;
}

.app-cta__qr-box {
  background: var(--color-white);
  border-radius: var(--radius-md);
  padding: 8px;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-cta__qr-placeholder {
  width: 80px;
  height: 80px;
  background: #e0e0e0;
  border-radius: 4px;
}

@media (min-width: 768px) {
  .app-cta {
    padding: 40px 0;
  }

  .app-cta__inner {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 48px 56px;
    text-align: left;
  }

  .app-cta__content {
    flex: 1;
  }

  .app-cta__title {
    font-size: 26px;
    max-width: 480px;
  }

  .app-cta__qr {
    flex-shrink: 0;
  }
}
</style>
